import { Badge } from 'react-bootstrap';
import { Color } from 'react-bootstrap/esm/types';

type IApiStatus =
  | 'pending'
  | 'booked'
  | 'approved'
  | 'rejected'
  | 'Paid'
  | 'Unpaid'
  | 'Partial Paid'
  | 'Under Review'
  | 'payment_pending'
  | 'payment_review'
  | null
  | undefined
  | '';

const CommonStatus = (apiStatus: IApiStatus) => {
  // Define all possible statuses including fallback
  const status: Record<
    Exclude<IApiStatus, null | undefined | ''>,
    { text: string; bg?: string; textColor?: Color | undefined }
  > = {
    pending: {
      text: 'Pending',
      bg: 'warning',
      textColor: 'dark',
    },
    booked: {
      text: 'Booked',
      bg: 'success',
    },
    approved: {
      text: 'Approved',
      bg: 'success',
    },
    Paid: {
      text: 'Paid',
      bg: 'success',
    },
    Unpaid: {
      text: 'Unpaid',
      bg: 'danger',
    },
    'Partial Paid': {
      text: 'Partial Paid',
      bg: 'primary',
    },
    'Under Review': {
      text: 'Under Review',
      bg: 'info',
    },
    rejected: {
      text: 'Rejected',
      bg: 'danger',
    },

    payment_pending: {
      text: 'Payment Pending',
      bg: 'warning',
      textColor: 'dark',
    },
    payment_review: {
      text: 'Payment Review',
      bg: 'warning',
      textColor: 'dark',
    },
  };

  // Handle null/undefined/empty cases
  if (!apiStatus) {
    return <span className='unknown-status'>Unknown</span>;
  }

  // Get the status or fallback to unknown
  const currentStatus = status[apiStatus] || { text: 'Unknown' };

  return (
    <Badge
      style={{ minWidth: '70px', width: '100%' }}
      bg={currentStatus?.bg}
      text={currentStatus?.textColor || undefined}
    >
      {currentStatus?.text}
    </Badge>
    // <span
    //   className={
    //     apiStatus === 'pending'
    //       ? 'pending'
    //       : apiStatus === 'approved'
    //       ? 'approved'
    //       : apiStatus === 'rejected'
    //       ? 'rejected'
    //       : apiStatus === 'booked'
    //       ? 'booked'
    //       : apiStatus === 'Paid'
    //       ? 'approved'
    //       : apiStatus === 'Unpaid'
    //       ? 'rejected'
    //       : apiStatus === 'Partial Paid'
    //       ? 'booked'
    //       : apiStatus === 'Under Review'
    //       ? 'rejected'
    //       : 'unknown-status'
    //   }
    // >
    //   {currentStatus.text}
    // </span>
  );
};

export default CommonStatus;
